import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { AuthService } from '../../services/auth/auth.service';

import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {

  open(menu)
  {
    menu.openMenu();
  }
  
  data = new Data();
  myId: any;
  payment = {
    account_number: null,
    amount: null,
    //contact_number: null
  };
  product: any;
  scannedData: any;
  barcodeScannerOptions: BarcodeScannerOptions;
  active = false;
  verify = false;
  error = false;
  myresponse: any;

  is_account_number = false;
  is_amount = false;
  //is_contact_number = false;


  current_year: number = new Date().getFullYear();

  constructor(private apiService: ApiService, private authService: AuthService, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.data =  {
      id: 4,
      name: 'getProduct',
      content: this.myId
    };

    this.barcodeScannerOptions = {
      showTorchButton: true,
      showFlipCameraButton: true
    };

  }

  ngOnInit() {
    this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
    });
  }

  getCatName() {
    if (this.product) {
      return this.product[0].dexpay_label;
    } else {
      return null;
    }
  }

  getProdName() {
    if (this.product) {
      return this.product[0].name;
    } else {
      return null;
    }
  }

  getProdImage() {
    if (this.product) {
      return '/assets/img/' + this.product[0].image;
    } else {
      return null;
    }
  }

  scanCode() {
    this.barcodeScanner
      .scan()
      .then(barcodeData => {
        this.scannedData = barcodeData;
        this.payment.account_number = this.scannedData.text;
      })
      .catch(err => {
        console.log('Error', err);
      });
  }

  scanCode2() {
      this.barcodeScanner
        .scan()
        .then(barcodeData => {
          this.scannedData = barcodeData;
          this.payment.amount = this.scannedData.text;
        })
        .catch(err => {
          console.log('Error', err);
        });
  }

//contact
/*scanCode3() {
    this.barcodeScanner
      .scan()
      .then(barcodeData => {
        this.scannedData = barcodeData;
        this.payment.contact_number = this.scannedData.text;
      })
      .catch(err => {
        console.log('Error', err);
      });
}*/

  
  
  checkInput() {
    if (this.myId === '126' || this.myId === '146' || this.myId === '147' || this.myId === '149' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if (this.payment.account_number.length == 12 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '137' || this.myId === '148' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if (this.payment.account_number.length == 13 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '136' || this.myId === '140' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if (this.payment.account_number.length == 16 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '138' || this.myId === '120' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if (this.payment.account_number.length == 15 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '142' || this.myId === '198' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if (this.payment.account_number.length == 17 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    //INDAH WATER OLD =8, NEW=11
    else if (this.myId === '116' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if((this.payment.account_number.length >= 8 || this.payment.account_number.length == 11) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '117' || this.myId === '125' || this.myId === '139' || this.myId === '196' || this.myId === '144' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      //196 astro 
      if (this.payment.account_number.length == 10 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '118' || this.myId === '121' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if (this.payment.account_number.length == 11 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '199' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if (this.payment.account_number.length == 9 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '119' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if (this.payment.account_number.length == 7 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    } 
    else if (this.myId === '122' || this.myId === '141' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if (this.payment.account_number.length == 14 && this.payment.amount >= 10)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }
    else if (this.myId === '200' || this.myId === '123' || this.myId === '203' || this.myId === '204' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if((this.payment.account_number.length >= 10 || this.payment.account_number.length == 12) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }
    }

    else if (this.myId === '127' || this.myId === '124' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if((this.payment.account_number.length >= 9 || this.payment.account_number.length == 12) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }
    }

    //redone bill min9-max11
    else if (this.myId === '143' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if((this.payment.account_number.length >= 9 || this.payment.account_number.length == 11) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }
    }

    else if (this.myId === '197' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if((this.payment.account_number.length >= 12 || this.payment.account_number.length == 16) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }    
    } 
    else if (this.myId === '132' || this.myId === '133' || this.myId === '135' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if((this.payment.account_number.length >= 12 || this.payment.account_number.length == 13) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }  
    } 
    else if (this.myId === '131' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if((this.payment.account_number.length >= 11 || this.payment.account_number.length == 13) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }  
    } 
    else if (this.myId === '134' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if((this.payment.account_number.length >= 8 || this.payment.account_number.length == 13) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }
    } 
    else if ( this.myId === '128' && this.payment.account_number !== null && this.payment.amount !== null) 
    {
      if((this.payment.account_number.length >= 9 || this.payment.account_number.length == 13) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }
    } 
    else if (this.myId === '130' && this.payment.account_number !== null && this.payment.amount !== null)
    {
      if((this.payment.account_number.length >= 5 || this.payment.account_number.length == 13) && (this.payment.amount >= 10))
      {
        this.active = true;
      }
      else
      {
        this.active = false;
      }    
    } 
    else 
    {
      this.active = false;
    }
  }
   

  submit() {
    this.spinner.show();
    // this.navCtrl.navigateForward('/members/success/485');
    /*const passcode =  this.pass[0].toString() + this.pass[1].toString() + this.pass[2].toString() + this.pass[3].toString() + this.pass[4].toString() + this.pass[5].toString();
    console.log(passcode);
    if ( passcode === '123456' ) {*/

    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - this.payment.amount;

    console.log(test + ' ' + balance);

    if (Number.parseFloat(test) >= this.payment.amount ) {
    const dt = {
        mobile: this.payment.account_number,
        amount: this.payment.amount,
        //contact
        //contact: this.payment.contact_number,
        product: this.myId,
        user: localStorage.getItem('user'),
        order: null,
		    rrp: this.payment.amount
      };

    this.data =  {
        id: 5,
        name: 'addOrder',
        content: dt
    };



    this.apiService.pay(this.data).subscribe((response) => {
        this.data.content.order = response;
        this.apiService.wallet(this.data).subscribe((res) => {
          this.navCtrl.navigateForward('/members/success/' + response);
          this.myresponse = res;
          // let resp = this.myresponse.split('#');
          console.log('azizi');
          console.log(this.myresponse);
          console.log(res);

          if (this.myresponse === 'Failed') {
            this.navCtrl.navigateForward('/members/failed/1');
            // localStorage.setItem('wallet', balance.toString());
            this.spinner.hide();
            console.log(res);
          } else {
            this.navCtrl.navigateForward('/members/success/' + response);
            localStorage.setItem('wallet', balance.toString());
            this.spinner.hide();
            console.log(res);
          }
      });
    });

  } else {
    this.verify = false;
    this.openDialog();
    this.spinner.hide();
  }

  /*  } else {
      console.log ('failed');
    }*/
  }


  verification() {
    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - this.payment.amount;

    console.log(test + ' ' + balance + ' ' + this.payment.amount);

    this.data =  {
      id: 10,
      name: 'checkAccountNo',
      content: this.payment.account_number
    };


    this.apiService.postData(this.data).subscribe((response) => {
      console.log(response);
      if ( response.data[0].isokay === 1 ) {
        this.verify = true;
        this.error = false;
      } 
      else {
        this.verify = false;
        this.error = true;
      }

    });
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogThirdPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  
  
  getMaxLimit() {
    if (this.myId === '126' || this.myId === '127' || this.myId === '200' || this.myId === '123' || this.myId === '146' || this.myId === '147' || this.myId === '149' || this.myId === '203' || this.myId === '204' || this.myId === '124') {
      return 12;
    }if (this.myId === '148' || this.myId === '128' || this.myId === '130' || this.myId === '131' || this.myId === '132' || this.myId === '133' || this.myId === '134' || this.myId === '135' || this.myId === '137') {
      return 13;
    } if (this.myId === '136' || this.myId === '140' || this.myId === '197') {
      return 16;
    } if (this.myId === '138' || this.myId === '120') {
      return 15;
    } if (this.myId === '142' || this.myId === '198') {
      return 17;
    } if (this.myId === '199') {
      return 9;
    } if (this.myId === '117' || this.myId === '125' || this.myId === '139' || this.myId === '196' || this.myId === '144') {
      return 10;
    } if (this.myId === '118' || this.myId === '121' || this.myId === '143' || this.myId === '116') {
      return 11;
    } if (this.myId === '119') {
      return 7;
    } if (this.myId === '141' || this.myId === '122'){
      return 14;
    } else 
    {
      return 0;
    }
  }




  getInputLabel() {
    if (this.myId === '128' || this.myId === '131' ||  this.myId === '132' ||  this.myId === '133' ||  this.myId === '134' ||  this.myId === '135' || this.myId === '126' || this.myId === '146' || this.myId === '147' || this.myId === '116' || this.myId === '117' || this.myId === '118' || this.myId === '119' || this.myId === '120' || this.myId === '121' || this.myId === '122' || this.myId === '125' || this.myId === '130' || this.myId === '198' || this.myId === '136' || this.myId === '137' || this.myId === '138' || this.myId === '139' || this.myId === '140' || this.myId === '141' || this.myId === '142' || this.myId === '149' || this.myId === '144' || this.myId === '148' || this.myId === '196' || this.myId === '199') {
      return 'Account No';
    }else if (this.myId === '124' || this.myId === '200' || this.myId === '203' || this.myId === '204') {
      return 'Mobile No';
    }else if (this.myId === '123' || this.myId === '127' || this.myId === '143') {
      return 'Account No/Mobile No';
    }else if (this.myId === '197') {
      return 'Credit Card No/Account No';
    }else {
      return null;
    }
  }


  getTermsCondition() {
    if (this.myId === '125' || this.myId === '126' || this.myId === '136' || this.myId === '137' || this.myId === '138' || this.myId === '146' || this.myId === '147' || this.myId === '116' || this.myId === '117' || this.myId === '119' || this.myId === '120' || this.myId === '121' || this.myId === '122' || this.myId === '139' || this.myId === '140' || this.myId === '141' || this.myId === '142' || this.myId === '149' || this.myId === '196' || this.myId === '127' || this.myId === '197' || this.myId === '143' || this.myId === '123' || this.myId === '124' || this.myId === '204' ) {
      return '1. Transaction amount is NOT ALLOWED CENTS. (Eg: RM10.20) \n2. Duplicate account number is ALLOWED for 1 time/day & 2 times/month. \n3. Minimum transaction amount is RM10.';
    }else if (this.myId === '118') {
        return '1. Transaction amount is NOT ALLOWED CENTS. (Eg: RM10.20) \n2. Duplicate account number is ALLOWED for 1 time/day & 5 times/month. \n3. Minimum transaction amount is RM10.';
    }else if (this.myId === '128' || this.myId === '130'  || this.myId === '131' || this.myId === '132' || this.myId === '133' || this.myId === '134' || this.myId === '135') {
        return '1. Transaction amount is NOT ALLOWED CENTS. (Eg: RM10.20) \n2. Duplicate account number is ALLOWED for 1 time/month. \n3. Minimum transaction amount is RM10.';
    }else if (this.myId === '200' || this.myId === '203') {
        return '1. Transaction amount is NOT ALLOWED CENTS. (Eg: RM10.20) \n2. Unlimited transaction. \n3. Minimum transaction amount is RM10.';
    }else if (this.myId === '144' || this.myId === '148' || this.myId === '199') {
        return '1. Transaction amount is NOT ALLOWED CENTS. (Eg: RM10.20) \n2. Duplicate account number is ALLOWED for maximum RM500/day & 3 times per month. \n3. Minimum transaction amount is RM10.';
    }else{
        return '**No T&C information regarding this product.';
    }
  }

  getTransactionProcess() {
    if (this.myId === '125' || this.myId === '126' || this.myId === '136' || this.myId === '142' || this.myId === '146' || this.myId === '147' || this.myId === '196' || this.myId === '127' || this.myId === '144' || this.myId === '199' || this.myId === '148'){
      return '1. Will process after 20 minutes.';
    }else if (this.myId === '116' || this.myId === '117' || this.myId === '119' || this.myId === '120' || this.myId === '121' || this.myId === '122' || this.myId === '128' || this.myId === '137' || this.myId === '138' || this.myId === '139' || this.myId === '140' || this.myId === '141' || this.myId === '149' || this.myId === '130' || this.myId === '131' || this.myId === '132' || this.myId === '133' || this.myId === '134' || this.myId === '135' || this.myId === '197' || this.myId === '123') {
      return '1. Within 3 working days.';
    }else if (this.myId === '118') {
      return '1. Within 24 hours.';
    }else if (this.myId === '200' || this.myId === '203' || this.myId === '204') {
      return '1. Will process immediately.';
    }else {
      return '**No Transaction Process information regarding this product.';
    }
  }

  logout() {
    this.authService.logout();
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogThirdPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
